import { Services } from "./services";

export function Privacy() {
  return (
    <div className="space-y-4">
      <Services />
    </div>
  );
}
